import { render, staticRenderFns } from "./AzList.vue?vue&type=template&id=51140cbd&"
import script from "./AzList.vue?vue&type=script&lang=js&"
export * from "./AzList.vue?vue&type=script&lang=js&"
import style0 from "./AzList.vue?vue&type=style&index=0&id=51140cbd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports